import { LABELS } from "~/resources/Labels";
import { TableHeaderType } from "../types/TableHeaderType";

export const CloudProvisionerTemplateHeader: TableHeaderType[] = [
  {
    label: LABELS.Name,
    key: 'fileName',
    id: 'fileName',
    sortable: true,
  },
  {
    label: LABELS.ProviderType,
    key: 'provider',
    id: 'provider',
    sortable: false,
  },
  {
    label: LABELS.LocationRegion,
    key: 'locationOrRegion',
    id: 'locationOrRegion',
    sortable: false,
  },
  {
    label: LABELS.SizesInstanceTypes,
    key: 'sizesOrTypes',
    id: 'sizesOrTypes',
    sortable: false,
  },
];
